<template>
   <el-container class="content" style="display: block;">


     <div :style="{'width':screenWidth,'height':screenHeight}" style="display: flex;flex-wrap: wrap;background-color: #000;overflow-y: scroll;">
       <div v-for="(video, index) in list" :key="index" style="padding: 1px;">

         <el-tooltip class="item" effect="dark" :content="video['name']" placement="bottom-start">
           <img :src="video['img']"  :width="vwidth" :height="vwidth" @click="open(video['url'])">
        </el-tooltip>
         <!-- <video :width="vwidth" :height="vwidth" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true">
           <source :src="video['url']" type="video/mp4">

         </video> -->
       </div>




     </div>
    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;" v-if="vshow" :style="{'width':screenHeight+'px','height':screenHeight+'px','left':(screenWidth-screenHeight)/2+'px'}">
      <video width="100%" height="98%" ref="videoPlayer" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo">
        <source :src="video_url" type="video/mp4">

      </video>
      <div style="position: absolute;right:-2%;top:2px;" @click="close()"><i class="el-icon-circle-close" style="font-size: 25px;color: #ffffff;"></i></div>
    </div>

    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>

   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        vshow:false,
        list:[],
        videos:[],
        video_url:'https://video.universepower.cn/yuzhouzhimi/2.mp4',
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        vwidth:(window.innerWidth-20)/20,
        vheight : window.innerHeight/200,

      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()




    },

	methods:{

    open(url){
      this.vshow = false
      this.video_url = ""

      setTimeout(() => {
        this.vshow = true
        this.video_url = url
        
        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },
    close(){
      this.vshow = false
      this.video_url = ""
      this.$refs.videoPlayer.pause();
    },
    cshows(){
      this.cshow = !this.cshow
      if(!this.cshow){
        this.cshow1 = false
        this.cshow2 = false
        this.cshow3 = false
      }

    },
    cshows1(){
      this.cshow1 = !this.cshow1
      if(this.cshow1){
        this.cshow2 = false
        this.cshow3 = false
      }
    },
    cshows2(){
      this.cshow2 = !this.cshow2
      if(this.cshow2){
        this.cshow1 = false
        this.cshow3 = false
      }
    },
    cshows3(){
      this.cshow3 = !this.cshow3
      if(this.cshow3){
        this.cshow1 = false
        this.cshow2 = false
      }
    },
    toPage(name){
      this.$router.push('/'+name);
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:'宇宙一次幂(深圳)机器人有限公司',


      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoList'
      })
      .then(res=>{
        this.list = res.data.list;


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.cdaohang{
  background-color: #000000;
}
ul li:hover{
  background-color: #cacaca;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }

/* //全屏按钮 */
/* video::-webkit-media-controls-fullscreen-button { */
/*    display: none;
} */
/* //播放按钮 */
/* video::-webkit-media-controls-play-button {
    display: none;
} */
/* //进度条 */
video::-webkit-media-controls-timeline {
    display: none;
}
/* //观看的当前时间 */
video::-webkit-media-controls-current-time-display{
    display: none;
}
/* //剩余时间 */
video::-webkit-media-controls-time-remaining-display {
    display: none;
}
/* //音量按钮 */
video::-webkit-media-controls-mute-button {
    display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
}
/* //音量的控制条 */
video::-webkit-media-controls-volume-slider {
    display: none;
}
/* 所有控件 */
/* video::-webkit-media-controls-enclosure{
    display: none;
} */




</style>



// WEBPACK FOOTER //
// src/components/main/shipin.vue